<template>
  <div id="rightMainContainer" style="width: 100%">
    <operations @pf="parent" @pf4="parent4"></operations>
    <div style="height: var(--middle-space); background: #f4f5fa"></div>
    <navAndSearch></navAndSearch>
    <fileTable ref="goodslist"></fileTable>
  </div>
</template>

<script>
import navAndSearch from "@/CommonDP/components/documentRelevant/returnLevel.vue";
import fileTable from "./fileTable/fileTable";
import operations from "./operations/operations";
import { mapState } from "vuex";
export default {
  name: "Mydoc",
  components: {
    navAndSearch,
    fileTable,
    operations
  },
  data() {
    return {
      argument1: {
        folderId: "",
        folderNew: 1,
        isPersonal: 1,
        isRead: 1,
        priviAll: "1",
        enterpriseId: "",
        type: "",
        versionId: ""
      }
    };
  },
  computed: {
    ...mapState({
      currentNode: (state) => state.perFile.currentTreeNodeDan,
      enterpriseId: (state) => state.enterprise.enterpriseId
    })
  },
  // 离开路由之前执行的函数
  beforeRouteLeave(to, from, next) {
    // 等于persondoc路由依然会加载persondoc下的第一个children，显示mydoc，此时不应该清空
    if (to.path !== "/persondoc") {
      this.$store.dispatch("perFileUpdateNavDan", []);
    }
    next();
  },
  created() {
    this.argument1.enterpriseId = this.enterpriseId;
  },
  methods: {
    parent() {
      this.argument1.folderId = this.currentNode.folderId;
      this.$refs.goodslist.querlist2(this.argument1);
    },
    parent4(data) {
      if (data) {
        this.$refs.goodslist.querlist4(data);
      } else {
        this.argument1.folderId = this.currentNode.folderId;
        this.$refs.goodslist.querlist2(this.argument1);
      }
    }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
#rightMainContainer {
  height: 100%;
  background-color: #fff;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  display: flex;
  flex-direction: column;
}
::v-deep span{
  font-size: 14px !important;
}
::v-deep .cell{
  font-size: 14px !important;
}
</style>
